import {pixels} from '../../abstract-units';
import {BoxEdge} from '../../edge';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {CELL_SIZE, EDGE_AREA_THICKNESS_PX, ZERO_POS} from './common';

const thickness = pixels(EDGE_AREA_THICKNESS_PX);
const bluntAnglePos = (totalPx: number) => totalPx - EDGE_AREA_THICKNESS_PX;

export const LEFT_EDGE_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.EDGE,
    boxEdge: BoxEdge.LEFT,
    vertices: [
        [ZERO_POS, ZERO_POS],  [thickness, thickness], // TOP_LEFT, TOP_RIGHT
        [ZERO_POS, CELL_SIZE], [thickness, bluntAnglePos] // BOTTOM_LEFT, BOTTOM_RIGHT
    ]
};
